// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headTilte {
    color: #333;
    font-family: Rockwell;
font-size: 22px;
font-weight: 400;
line-height: 31px;
letter-spacing: 0em;
text-align: center;

}
.card {
    border: none;
}

.name{
    font-family: 'Rockwell';
font-size: 14px;
font-weight: 400;
line-height: 20px;
letter-spacing: 0.20000000298023224px;
text-align: left;

}

.imgbox {
    display: grid;
    height: 100%;
}

.center-fit {
    max-width: 100%;
    max-height: 100vh;
    margin: auto;
}

.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
}

.loading-text {
    font-size: 20px;
    color: #FF7F50;
}

.dots::after {
    content: '';
    display: inline-block;
    width: 1em;
    text-align: left;
    animation: dots 1.5s steps(4, end) infinite;
}

@keyframes dots {
    0%, 20% {
        content: '';
    }

    40% {
        content: '.';
    }

    60% {
        content: '..';
    }

    80%, 100% {
        content: '...';
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Gameprofile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,qBAAqB;AACzB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,mBAAmB;AACnB,kBAAkB;;AAElB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;;AAEhB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".headTilte {\n    color: #333;\n    font-family: Rockwell;\nfont-size: 22px;\nfont-weight: 400;\nline-height: 31px;\nletter-spacing: 0em;\ntext-align: center;\n\n}\n.card {\n    border: none;\n}\n\n.name{\n    font-family: 'Rockwell';\nfont-size: 14px;\nfont-weight: 400;\nline-height: 20px;\nletter-spacing: 0.20000000298023224px;\ntext-align: left;\n\n}\n\n.imgbox {\n    display: grid;\n    height: 100%;\n}\n\n.center-fit {\n    max-width: 100%;\n    max-height: 100vh;\n    margin: auto;\n}\n\n.loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25vh;\n}\n\n.loading-text {\n    font-size: 20px;\n    color: #FF7F50;\n}\n\n.dots::after {\n    content: '';\n    display: inline-block;\n    width: 1em;\n    text-align: left;\n    animation: dots 1.5s steps(4, end) infinite;\n}\n\n@keyframes dots {\n    0%, 20% {\n        content: '';\n    }\n\n    40% {\n        content: '.';\n    }\n\n    60% {\n        content: '..';\n    }\n\n    80%, 100% {\n        content: '...';\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
